import {
  PendingApprovalMetadataSchema,
  type PendingApprovalMetadataType,
} from "@validereinc/domain";

/**
 * Generic approval field model rendered by PendingApprovalCard.
 */
export type ApprovalFieldType = {
  label: string;
  values: string[];
};

const buildRegistrationFields = (
  metadata: PendingApprovalMetadataType
): ApprovalFieldType[] => [
  { label: "API", values: [metadata.spec_summary.title] },
  { label: "Version", values: [metadata.spec_summary.version] },
  { label: "OpenAPI", values: [metadata.spec_summary.openapi_version] },
  { label: "Key", values: [metadata.key] },
  { label: "Hosts", values: metadata.hosts },
  ...(metadata.post_read_suffixes?.length
    ? [{ label: "Post-read suffixes", values: metadata.post_read_suffixes }]
    : []),
];

/**
 * Maps known pending-approval payloads into generic card fields.
 */
export const buildApprovalFields = (metadata: unknown): ApprovalFieldType[] => {
  const parsedPendingApprovalMetadata =
    PendingApprovalMetadataSchema.safeParse(metadata);
  if (!parsedPendingApprovalMetadata.success) {
    return [];
  }

  return buildRegistrationFields(parsedPendingApprovalMetadata.data);
};
